var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-principle-main",class:{ 'product-principle-main-mobile': _vm.isMobile }},[_c('Base-title',{attrs:{"title":"贝壳隐私保护原则"}}),_c('div',{staticClass:"headers"},[_vm._v(" 贝壳隐私，从心触发，全心守护 ")]),_c('Principle')],1)}
var staticRenderFns = []

export { render, staticRenderFns }